import React from 'react';

function SellerDashboard() {
	// This is where sellers manage their products
	return (
		<div className='p-6'>
			<h2 className='text-2xl font-bold mb-6'>Seller Dashboard</h2>
			<p>Manage your fabrics and orders here.</p>
			{/* Additional features and components for managing fabrics */}
		</div>
	);
}

export default SellerDashboard;
